/**
 * @generated SignedSource<<996baf842518c560d92fa90620d8723d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditModeRealmData$data = {
  readonly blocks: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PlaylistEditModeBlockData" | "SeriesEditModeBlockData" | "TextEditModeBlockData" | "TitleEditModeBlockData" | "VideoEditModeBlockData">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"EditModeFormRealmData">;
  readonly " $fragmentType": "EditModeRealmData";
};
export type EditModeRealmData$key = {
  readonly " $data"?: EditModeRealmData$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditModeRealmData">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditModeRealmData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "blocks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TitleEditModeBlockData"
            }
          ],
          "type": "TitleBlock",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "TextEditModeBlockData"
            }
          ],
          "type": "TextBlock",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeriesEditModeBlockData"
            }
          ],
          "type": "SeriesBlock",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "VideoEditModeBlockData"
            }
          ],
          "type": "VideoBlock",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PlaylistEditModeBlockData"
            }
          ],
          "type": "PlaylistBlock",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditModeFormRealmData"
    }
  ],
  "type": "Realm",
  "abstractKey": null
};

(node as any).hash = "332c1b24631ef30e3ce0025b920923a0";

export default node;
